import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('components.Drawer.Promotion', {
    heading: 'New features available',
    tryThemFor14DaysForFree: 'Try them for 14 days for free',
    tryNow: 'Try now',
});
